import axios from "axios";
import {preparePreviewRequest, validatePreviewResponse} from "./preview-request.mjs";

const API = "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use(preparePreviewRequest);
api.interceptors.response.use(validatePreviewResponse);

export function formatApiError(detail) {
  if (detail == null) return "Er is iets misgegaan. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
